/*jshint browserify: true */
'use strict';

var InteractionMode = require('./InteractionMode.js');

/**
 * @name BoxDrawMode
 *
 * A base mode for drawing boxes. Inherit this for other modes that
 * involve box drawing.
 */
var BoxDrawMode = (function BoxDrawModeClosure() {
    function BoxDrawMode(pdfElements, selectedPdfElements, pages) {
        InteractionMode.call(this, pdfElements, selectedPdfElements, pages);

        this._mouseIsDown = false;
        this._mouseStart = null;
        this._mouseStartPage = null;
        this._mouseEnd = null;
        this._mouseEndPage = null;
    }

    BoxDrawMode.colourSettings = {
        borderColour: '#ff0000',
        borderAlpha: 1,
        borderWidth: 2,
        fillColour: '#c0c0c0',
        fillAlpha: 0.8
    };


    BoxDrawMode.prototype = Object.create(InteractionMode.prototype);
    BoxDrawMode.prototype.constructor = BoxDrawMode;

    BoxDrawMode.prototype.onMouseDown = function (mouseEvent, page) {
        if (mouseEvent.button === 0) {
            this._mouseIsDown = true;
            this._mouseStart = coordinates.Position.fromMouseEvent(mouseEvent, page.pageViewport, page.pdfOverlayCanvasElement);
            this._mouseStartPage = page;
            this._mouseEnd = this._mouseStart;
            this._mouseEndPage = page;
        }
    };

    BoxDrawMode.prototype.onMouseUp = function (mouseEvent, page) {
        if (mouseEvent.button === 0 && this._mouseIsDown === true && this._mouseStartPage === page) {
            this._mouseIsDown = false;
            this._mouseStartPage = null;
            this._mouseEnd = coordinates.Position.fromMouseEvent(mouseEvent, page.pageViewport, page.pdfOverlayCanvasElement);
            this._mouseEndPage = page;
        }
    };

    BoxDrawMode.prototype.onMouseMove = function (mouseEvent, page) {
        if (this._mouseIsDown === true) {
            this._mouseEnd = coordinates.Position.fromMouseEvent(mouseEvent, page.pageViewport, page.pdfOverlayCanvasElement);
            this._mouseEndPage = page;
        }
    };

    BoxDrawMode.prototype.renderToCanvas = function (page, colourSettings) {
        if (colourSettings === undefined || colourSettings === null) {
            colourSettings = BoxDrawMode.colourSettings;
        }

        if (this._mouseIsDown === true && this._mouseStartPage === page) {
            page.pdfOverlayCanvasContext.save();

            page.pdfOverlayCanvasContext.fillStyle = colourSettings.fillColour;
            page.pdfOverlayCanvasContext.globalAlpha = colourSettings.fillAlpha;
            page.pdfOverlayCanvasContext.fillRect(this._mouseStart.viewportX + 1.0, this._mouseStart.viewportY + 1.0, this._mouseEnd.viewportX - this._mouseStart.viewportX - 1.0, this._mouseEnd.viewportY - this._mouseStart.viewportY - 1.0);

            page.pdfOverlayCanvasContext.restore();
            page.pdfOverlayCanvasContext.save();

            page.pdfOverlayCanvasContext.strokeStyle = colourSettings.borderColour;
            page.pdfOverlayCanvasContext.lineWidth = colourSettings.borderWidth;
            page.pdfOverlayCanvasContext.globalAlpha = colourSettings.borderAlpha;
            page.pdfOverlayCanvasContext.strokeRect(this._mouseStart.viewportX + 0.5, this._mouseStart.viewportY + 0.5, this._mouseEnd.viewportX - this._mouseStart.viewportX, this._mouseEnd.viewportY - this._mouseStart.viewportY);

            page.pdfOverlayCanvasContext.restore();
        }
    };

    return BoxDrawMode;
})();

module.exports = BoxDrawMode;

var coordinates = require('../Coordinates');